import { useContext } from 'react'
import { EditorCommandsContext } from '@/contexts/editor-commands-context'

/**
 * The editor's Select None command, for a Type panel control that has to deselect on Escape itself.
 *
 * A focused icon's tooltip consumes the first Escape (Radix closes it and calls `preventDefault`),
 * and the canvas's Escape handler stands down for a press something else already handled, so the
 * selection would take a second press to clear (WMPCM-9464 AC 3). Optional on purpose: the panel is
 * rendered on its own in tests, and with no provider there is simply nothing to clear.
 */
export function useClearSelectionCommand(): (() => void) | undefined {
  return useContext(EditorCommandsContext)?.selectNone
}
